import { NavLink, useLocation } from 'react-router-dom'
import clsx from 'clsx'

import { Logo, IconSvg } from 'components/common'
import { SidebarDevBlock } from 'components/organisms/sidebar-dev-block'
import { getNavigationItems, getManageEventsNavigationItems } from 'utils/constants'

export function MainSidebar() {
	const navigationItems = getNavigationItems()
	const manageEventsItems = getManageEventsNavigationItems()
	const { pathname } = useLocation()
	const isManageEventsContext = pathname.startsWith('/manage/rep-clubs') || pathname.startsWith('/rep-club')

	const renderNavItem = (item: { name: string; href: string; icon: string; disabled: boolean }) => (
		<NavLink
			key={item.name}
			to={item.href}
			className={({ isActive }) =>
				clsx(
					'group flex items-center px-4 py-3 transition-[color,background-color] duration-hover ease-hover-ease font-medium',
					{
						'text-secondary-text': !isActive,
						'pointer-events-none text-white/10': item.disabled,
					}
				)
			}
		>
			{({ isActive }) => (
				<>
					<IconSvg
						icon={item.icon}
						className={clsx('mr-2 w-6 group-hover:text-primary', {
							'text-primary': isActive,
						})}
						aria-hidden="true"
					/>
					<span className="group-hover:text-white">{item.name}</span>
				</>
			)}
		</NavLink>
	)

	return (
		<div className="hidden lg:flex lg:flex-shrink-0 min-[1440px]:w-[1440px] w-full fixed top-0 left-1/2 -translate-x-1/2">
			<div className="flex flex-col w-[232px] absolute top-0 left-0 h-screen">
				<div className="flex-1 flex flex-col min-h-0 px-4">
					<div className="flex-1 flex flex-col py-4 overflow-y-auto">
						<div className="px-4 flex items-center">
							<a href="/">
								<Logo />
							</a>
						</div>
						<nav className="flex-1 mt-8 flex flex-col" aria-label="Sidebar">
							<div className="space-y-2">
								{navigationItems.map(renderNavItem)}
							</div>
							{isManageEventsContext && (
								<div className="space-y-2 mt-4 pt-4 border-t border-white/[0.08]">
									{manageEventsItems.map(renderNavItem)}
								</div>
							)}
							<SidebarDevBlock />
						</nav>
					</div>
				</div>
			</div>
		</div>
	)
}
